import { z } from "zod";
import { zObjectId } from "@dobrh-monorepo/core";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";

const requestSchema = z.object({
  serviceId: zObjectId(),
  newStatus: z.enum(["DRAFT", "ACTIVE"]),
});

// TODO: update to match service resource
const responseSchema = z.any();

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
